import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import { connect } from 'react-redux';

import { GDPR_POPUP_ID } from 'Component/GdprPopup/GdprPopup.config';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import { showPopup } from 'Store/Popup/Popup.action';
import { CustomerFormValuesType } from 'Type/Account.type';
import { MixType } from 'Type/Common.type';
import { GdprInformationsType } from 'Type/Gdpr.type';
import { appendWithStoreCode } from 'Util/Url';

import GdprConsent from './GdprConsent.component';

/** @namespace PeggysagePwa/Component/GdprConsent/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    privacyInformations: state.GdprReducer.privacyInformations,
    isLoadingGdpr: state.GdprReducer.isLoading
});

/** @namespace PeggysagePwa/Component/GdprConsent/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    hideActiveOverlay: () => dispatch(hideActiveOverlay()),
    showPopup: (popupId, payload) => dispatch(showPopup(popupId, payload))
});

/** @namespace PeggysagePwa/Component/GdprConsent/Container */
export class GdprConsentContainer extends PureComponent {
    static propTypes = {
        location: PropTypes.string.isRequired,
        mix: MixType,
        formId: PropTypes.string,
        cacheLifetime: PropTypes.number,
        hideActiveOverlay: PropTypes.func.isRequired,
        showPopup: PropTypes.func.isRequired,
        privacyInformations: GdprInformationsType.isRequired,
        isLoadingGdpr: PropTypes.bool.isRequired,
        onChange: PropTypes.func,
        defaultValues: CustomerFormValuesType
    };

    static defaultProps = {
        mix: {},
        formId: null,
        cacheLifetime: 60,
        onChange: null,
        defaultValues: {}
    };

    state = {
        // isLoading: true,
        gdprConsents: [],
        isPopupEnabled: false,
        privacyPolicy: ''
    };

    containerFunctions = {
        onChange: this.onChange.bind(this)
    };

    elemRef = createRef();

    componentDidMount() {
        this.getGdprConsents();
    }

    componentDidUpdate(prevProps) {
        const { privacyInformations } = this.props;
        const { privacyInformations: prevPrivacyInformations } = prevProps;

        if (privacyInformations !== prevPrivacyInformations) {
            this.getGdprConsents();
        }
    }

    onChange(event) {
        const { onChange } = this.props;

        if (onChange) {
            /* const { current: elem } = this.elemRef;

            if (!elem) {
                return;
            }

            const isValid = validateGroup(elem);

            onChange(event, isValid); */
            onChange(event);
        }
    }

    getGdprConsents() {
        const {
            privacyInformations: { consents, isPopupEnabled, privacyPolicy },
            location
        } = this.props;

        if (!consents || !Object.keys(consents).length) {
            return;
        }

        const gdprConsents = consents[location]?.map((consent) => {
            const ref = createRef();
            return { ...consent, ref };
        }) || [];

        this.setState({
            gdprConsents,
            isPopupEnabled,
            privacyPolicy
        }, () => this.addEventListenersOnLinks());
    }

    addEventListenersOnLinks() {
        const { gdprConsents } = this.state;

        gdprConsents.forEach((consent) => {
            const label = consent.ref && consent.ref.current;
            if (!label) {
                return;
            }

            const links = label.querySelectorAll('a');
            if (links.length) {
                links.forEach((elt) => {
                    elt.addEventListener('click', this.onLinkClick.bind(this, consent));
                });
            }
        });
    }

    onLinkClick(gdprConsent, event) {
        const { hideActiveOverlay, showPopup, privacyInformations: { privacyPolicy } } = this.props;
        const { name, link_type, cms_page_identifier } = gdprConsent;

        event.preventDefault();
        event.stopPropagation();

        if (link_type) {
            // Open in new tab
            window.open(appendWithStoreCode(cms_page_identifier), '_blank');
        } else {
            // Open privacyPolicy on popup
            hideActiveOverlay();
            showPopup(
                GDPR_POPUP_ID,
                {
                    title: name,
                    html: privacyPolicy
                }
            );
        }
    }

    containerProps() {
        const {
            location, mix, formId, isLoadingGdpr: isLoading, defaultValues
        } = this.props;
        const { gdprConsents, isPopupEnabled, privacyPolicy } = this.state;

        return {
            location,
            mix,
            formId,
            isLoading,
            defaultValues,
            gdprConsents,
            isPopupEnabled,
            privacyPolicy,
            elemRef: this.elemRef
        };
    }

    render() {
        return (
            <GdprConsent
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GdprConsentContainer);
